import { render, staticRenderFns } from "./ChangeCompanyStatusDialog.vue?vue&type=template&id=e6bb7aca&"
import script from "./ChangeCompanyStatusDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeCompanyStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports